import {useSelector} from 'react-redux';

import {
    selectIsDeviceRegistrationErrorModalVisible,
    selectIsHolderRegistrationModalVisible,
} from '@/state/selectors/modal';
import {selectConnectionError} from '@/state/selectors/mw';

const useIsConnectionProcessPaused = () => {
    const isDeviceRegistrationErrorModalVisible = useSelector(selectIsDeviceRegistrationErrorModalVisible);
    const isHolderRegistrationModalVisible = useSelector(selectIsHolderRegistrationModalVisible);
    const connectionError = useSelector(selectConnectionError);

    return isDeviceRegistrationErrorModalVisible || isHolderRegistrationModalVisible || connectionError?.isNew;
};

export default useIsConnectionProcessPaused;
